import React from 'react'
import Menu from './menu'

export default props => (
    <asaide className='main-sidebar'>
        <section className='sidebar'>
            <Menu/>
        </section>
    </asaide>
)


// WEBPACK FOOTER //
// ./src/common/template/sideBar.jsx